import Vue from 'vue'
import VueGtm from '@gtm-support/vue2-gtm'
import router from '@/router'
import { getEnvironment } from '@/utils/env-helper'
import { GTM_ID } from '@/constants/config'

Vue.use(VueGtm, {
  id: GTM_ID,
  defer: true,
  compatibility: false,
  nonce: '2726c7f26c',
  enabled: getEnvironment() === 'Live',
  debug: false,
  loadScript: true,
  vueRouter: router,
  ignoredViews: [],
  trackOnNextTick: true,
})
